const STORAGE_KEY = "romi_campaign_attribution_v1";

const clean = (value, max = 240) =>
  Array.from(String(value || ""))
    .filter((character) => {
      const code = character.charCodeAt(0);
      return code >= 32 && code !== 127;
    })
    .join("")
    .trim()
    .slice(0, max);

const firstParam = (params, names) => {
  for (const name of names) {
    const value = clean(params.get(name));
    if (value) return value;
  }
  return "";
};

const cookieValue = (name) => {
  if (typeof document === "undefined") return "";
  const prefix = `${name}=`;
  const item = document.cookie
    .split(";")
    .map((value) => value.trim())
    .find((value) => value.startsWith(prefix));
  if (!item) return "";
  try {
    return decodeURIComponent(item.slice(prefix.length));
  } catch {
    return item.slice(prefix.length);
  }
};

const readStored = () => {
  if (typeof window === "undefined") return {};
  try {
    const value = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || "{}");
    return value && typeof value === "object" && !Array.isArray(value) ? value : {};
  } catch {
    return {};
  }
};

const store = (value) => {
  if (typeof window === "undefined") return;
  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(value));
  } catch {
    // El pedido debe continuar incluso si el navegador bloquea sessionStorage.
  }
};

export function collectCampaignAttribution({ includeMetaIdentifiers = true } = {}) {
  if (typeof window === "undefined") return {};
  const params = new URLSearchParams(window.location.search);
  const utmSource = firstParam(params, ["utm_source"]);
  const utmCampaign = firstParam(params, ["utm_campaign"]);
  const utmContent = firstParam(params, ["utm_content"]);
  const utmTerm = firstParam(params, ["utm_term"]);
  const fbclid = includeMetaIdentifiers ? firstParam(params, ["fbclid"]) : "";
  const current = {
    utmSource,
    utmMedium: firstParam(params, ["utm_medium"]),
    utmCampaign,
    utmContent,
    utmTerm,
    utmId: firstParam(params, ["utm_id"]),
    fbclid,
    fbc: includeMetaIdentifiers
      ? clean(cookieValue("_fbc"), 600) || (fbclid ? `fb.1.${Date.now()}.${fbclid}` : "")
      : "",
    fbp: includeMetaIdentifiers ? clean(cookieValue("_fbp"), 240) : "",
    // ROMI publica los IDs dinámicos de Meta en utm_campaign/term/content.
    // También aceptamos nombres explícitos para no perder compatibilidad futura.
    campaignId: firstParam(params, ["campaign_id", "campaignid"]) || utmCampaign,
    adsetId: firstParam(params, ["adset_id", "adsetid"]) || utmTerm,
    adId: firstParam(params, ["ad_id", "adid"]) || utmContent,
    creativeId: firstParam(params, ["creative_id", "creativeid", "romi_creative_id"]),
    placement: firstParam(params, ["placement", "romi_placement"]),
    siteSourceName: firstParam(params, ["site_source_name"]) || utmSource,
    landingUrl: clean(`${window.location.origin}${window.location.pathname}`, 1200),
  };
  const captured = Object.fromEntries(
    Object.entries(current).filter(([, value]) => Boolean(value)),
  );
  const merged = Object.keys(captured).length > 1
    ? { ...readStored(), ...captured }
    : readStored();
  if (Object.keys(merged).length) store(merged);
  return merged;
}

// Conserva la campaña al entrar, sin leer cookies de Meta ni crear fbc antes
// de que el cliente autorice la medición mejorada en el formulario.
export function primeCampaignAttribution() {
  return collectCampaignAttribution({ includeMetaIdentifiers: false });
}
